import { render, staticRenderFns } from "./InsightsV2Page.vue?vue&type=template&id=7533580a"
import script from "./InsightsV2Page.vue?vue&type=script&lang=js"
export * from "./InsightsV2Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports